import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesBook: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.81 1.52h24.38v1.53H5.34v1.52h22.85V6.1H3.81v1.52h1.53v22.86H3.81V32h25.91v-1.52H6.86V7.62h22.86v22.86h1.52V6.1h-1.52V1.52h1.52V0H3.81z\"/><path fill=\"currentColor\" d=\"M23.62 24.38h1.53v1.53h-1.53Zm1.53-12.19h-1.53v-1.52H12.96v1.52h-1.53v1.53H9.91v10.66h1.52v-6.09h1.53v-1.53h1.52v-1.52h7.62v1.52h1.52v1.53h1.53v6.09h1.52V13.72h-1.52zM12.96 25.91h10.66v1.52H12.96Z\"/><path fill=\"currentColor\" d=\"M20.57 21.33h1.53v1.53h-1.53Zm0-3.04h1.53v1.52h-1.53ZM16 22.86h4.57v1.52H16Zm-1.52-1.53H16v1.53h-1.52Zm0-3.04H16v1.52h-1.52Zm-3.05 6.09h1.53v1.53h-1.53Zm-9.14 4.57h1.52v1.53H2.29Zm0-27.43h1.52v1.53H2.29Zm0 4.58h1.52V4.57H2.29V3.05H.76v25.9h1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesBook
